// extracted by mini-css-extract-plugin
export default {"reservation-details-container":"GuestDetailsSection_reservation-details-container__83ezV"};